(ns frontend.test.input.view
  (:require [cljs-uuid-utils.core :as uuid]
            [common.currencies :as currencies]
            [common.localization :as loc]
            [common.schema.data-types :as data-types]
            [reagent.core :as r]
            [ui.editors.data-input :as data-input]
            [ui.view.page.view :as page]))

(def state (r/atom {}))

#_(js/setInterval (fn []
                    (let [new-val (uuid/uuid-string (uuid/make-random-uuid))]
                      (js/console.log "Interval : " new-val)
                      (swap! state assoc :data.type/text-simple new-val)))
                  5000)

(defn view
  []
  [page/centered
   (->> data-types/zapflow-data-types
        (keys)
        (remove #{:data.type/financials :data.type/tesi-financials :data.type/tesi-financials-2
                  :data.type/text-multi :data.type/keyword-multi :data.type/url-multi
                  :data.type/email-multi :data.type/id :data.type/text :data.type/text-edn})
        (sort-by loc/tr)
        (map (fn [data-type]
               ^{:key (str "input-test-" data-type)}
               [:div.flex.flex-col
                [:div.flex.flex-row.gap-4
                 [:h2.flex.shrink-0.grow-0.w-40.align-items-center.underline
                  (name data-type)]
                 [:div.flex.flex-col.flex-1.bg-base-light.p-4.text-base-light-text
                  [data-input/view
                   {:data-type data-type
                    :value     (get @state data-type)
                    :options   (case data-type
                                 :data.type/currency-symbol currencies/value-options
                                 :data.type/keyword [{:value :key-1
                                                      :label "Key 1"}
                                                     {:value :key-2
                                                      :label "Key 2"}]
                                 :data.type/ref-single [{:value 1
                                                         :label "Ref 1"}
                                                        {:value 2
                                                         :label "Ref 2"}]
                                 :data.type/ref-multi (->> (range 1 10)
                                                           (map (fn [i]
                                                                  {:value i
                                                                   :label (str "Ref " i)}))
                                                           (doall))
                                 nil)
                    :on-blur   (fn [v]
                                 (swap! state assoc data-type v))
                    :on-change (fn [v v-opts]
                                 (swap! state assoc data-type (or v-opts v)))}]]
                 [:div.flex.flex-col.flex-1.bg-base.p-4.text-base-text
                  [data-input/view
                   {:data-type  data-type
                    :variant    :borderless
                    :class      "border-0"
                    :style-opts {:border "none"}
                    :value      (get @state data-type)
                    :options    (case data-type
                                  :data.type/currency-symbol currencies/value-options
                                  :data.type/keyword [{:value :key-1
                                                       :label "Key 1"}
                                                      {:value :key-2
                                                       :label "Key 2"}]
                                  :data.type/ref-single [{:value 1
                                                          :label "Ref 1"}
                                                         {:value 2
                                                          :label "Ref 2"}]
                                  :data.type/ref-multi (->> (range 1 10)
                                                            (map (fn [i]
                                                                   {:value i
                                                                    :label (str "Ref " i)}))
                                                            (doall))
                                  nil)
                    :on-blur    (fn [v]
                                  (swap! state assoc data-type v))
                    :on-change  (fn [v v-opts]
                                  (swap! state assoc data-type (or v-opts v)))}]]

                 ]]))
        (doall))])
